import { TaskNew } from '../../plugins/api'

export default {
  namespaced: true,
  state: {
    listUsers: [],
    tasks: [],
    taskHistories: [],
  },
  mutations: {
    setListUsers(state, users) {
      state.listUsers = users
    },
    setTasks(state, tasks) {
      state.tasks = tasks
    },
    setTaskHistories(state, histories) {
      state.taskHistories = histories
    },
  },
  actions: {
    async createTaskNew(_, taskData) {
      try {
        await TaskNew.create({ ...taskData })
        return true
      } catch (error) {
        console.error(error)
        return false
      }
    },
    async deleteTaskNew(_, taskId) {
      try {
        await TaskNew.remove(taskId)
        return true
      } catch (error) {
        console.error(error)
        return false
      }
    },
    async findUsersExcludeRoles({ commit }, { page, limit, keyword }) {
      try {
        const user_exclu = await TaskNew.findUsersExcludeRoles({ page, limit, keyword })
        commit('setListUsers', user_exclu)
        return user_exclu
      } catch (error) {
        console.error(error)
        return false
      }
    },
    async findTaskByFilter({ commit }, options) {
      try {
        const tasks = await TaskNew.findTaskByFilter(options)
        commit('setTasks', tasks.data)
        return tasks
      } catch (error) {
        console.error(error)
        return []
      }
    },
    async fetchTaskHistory({ commit }, taskId) {
      try {
        const res = await TaskNew.findHistoryTask(taskId)
        commit('setTaskHistories', res)
        return res
      } catch (err) {
        return []
      }
    },
    async updateTask(_, data) {
      try {
        const res = await TaskNew.updateTask(data)
        return res
      } catch (error) {
        console.error(error)
        throw error
      }
    },
    async fetchTaskReport(_, options) {
      try {
        const tasks_report = await TaskNew.findTaskReport(options)
        return tasks_report
      } catch (error) {
        console.error(error)
        return []
      }
    },
    async countTaskReport(_, options) {
      try {
        const tasks_report = await TaskNew.countTaskReport(options)
        return tasks_report
      } catch (error) {
        console.error(error)
        return []
      }
    },
    async findTaskByReceiver(_, options) {
      try {
        const tasks_report = await TaskNew.findTaskByReceiver(options)
        return tasks_report
      } catch (error) {
        console.error(error)
        return []
      }
    },
  },
  getters: {
    listUsers: state => state.listUsers,
    tasks: state => state.tasks,
  },
}
